import React from "react";
import { Button } from "antd";
import { useBotEndpoint } from "../_actions/bot";
import { queryClient } from "../_helpers/query";

export default function FestivalImageGenerator({ festival }) {
    const generateImage = useBotEndpoint(
        "/gen/festival_feature_image",
        (res) => {
            if (res?.success) {
                queryClient.invalidateQueries(["items", "qdb_event"]);
            }
        }
    );

    return (
        <Button
            size="small"
            type="dashed"
            loading={generateImage.isLoading}
            onClick={() => {
                generateImage.mutate({ event_id: festival.id });
            }}
        >
            Generate Image
        </Button>
    );
}
